// src/pages/HomePage/HomePage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';

import Title from '../../components/common/Title/Title';
import FullScreenMessage from '../../components/common/FullScreenMessage/FullScreenMessage';
import FormListItem from '../../components/FormListItem/FormListItem';
import {FiPlusCircle, FiSearch} from 'react-icons/fi';
import styles from './HomePage.module.css';

import {hideBackButton} from "../../services/telegramService.js";
import useDebounce from "../../hooks/useDebounce";
import Input from "../../components/common/Input/Input";

const HomePage = () => {
    const [forms, setForms] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [initialLoad, setInitialLoad] = useState(true); // Флаг для первой загрузки
    const navigate = useNavigate();
    const intl = useIntl();
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();

    const [searchTerm, setSearchTerm] = useState('');
    const [activeFilter, setActiveFilter] = useState('all');
    const debouncedSearchTerm = useDebounce(searchTerm, 500); // Задержка в 500ms

    useEffect(() => {
        hideBackButton();
    }, []);

    useEffect(() => {
        const fetchForms = async () => {
            // if (initialLoad) {
            //     showPageLoader(); // Показываем лоадер только при первой загрузке страницы
            // }
            setIsLoading(true);

            const params = {
                search: debouncedSearchTerm,
                status: activeFilter,
            };

            try {
                // Запрос к API для получения списка форм
                const response = await get('forms', params); // GET /api/v1/forms
                if (response.data) {
                    setForms(response.data); // Устанавливаем данные из response.data
                }
            } catch (error) {
                addNotification(
                    error.message || intl.formatMessage({ id: "home.loadingError" }),
                    'error'
                );
            } finally {
                // if (initialLoad) {
                //     hidePageLoader();
                //     setInitialLoad(false);
                // }
                setIsLoading(false)
            }
        };

        fetchForms();
    }, [debouncedSearchTerm, activeFilter, addNotification, intl]);

    // Если идет первая загрузка, показываем лоадер (или пустой экран, т.к. лоадер - оверлей)
    // if (initialLoad) {
    //     return null;
    // }

    // Рендеринг контента
    return (
        <div>
            <Title><FormattedMessage id="home.pageTitle" /></Title>

            <div className={styles.controls}>
                <Input
                    wrapperClassName={styles.searchInputWrapper}
                    placeholder={intl.formatMessage({ id: "home.search.placeholder" })}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <div className={styles.filterButtons}>
                    <button
                        className={activeFilter === 'all' ? styles.activeFilter : ''}
                        onClick={() => setActiveFilter('all')}
                    ><FormattedMessage id="home.filter.all" /></button>
                    <button
                        className={activeFilter === 1 ? styles.activeFilter : ''}
                        onClick={() => setActiveFilter(1)}
                    ><FormattedMessage id="home.filter.active" /></button>
                    <button
                        className={activeFilter === 0 ? styles.activeFilter : ''}
                        onClick={() => setActiveFilter(0)}
                    ><FormattedMessage id="home.filter.draft" /></button>
                </div>
            </div>

            <div className={styles.listContainer}>
                {isLoading ? (
                    <div className={styles.loaderContainer}><div className={styles.spinner}></div></div>
                ) : forms.length > 0 ? (
                    forms.map(form => (
                        <FormListItem key={form.id} form={form} />
                    ))
                ) : (
                    <FullScreenMessage
                        icon={<FiPlusCircle size={48}/>}
                        title={intl.formatMessage({ id: "home.noForms.title", defaultMessage: "Формы не найдены" })}
                        text={intl.formatMessage({ id: "home.noForms.text", defaultMessage: "Попробуйте изменить фильтры или создайте новую форму." })}
                        buttonProps={{
                            text: intl.formatMessage({ id: "nav.create" }),
                            onClick: () => navigate('/create'),
                        }}
                    />
                )}
            </div>

            {/*<div className={styles.listContainer}>*/}
            {/*    {forms.length === 0 ? (*/}
            {/*        <FullScreenMessage*/}
            {/*            icon={<FiPlusCircle size={48} />}*/}
            {/*            title={intl.formatMessage({ id: "home.noForms.title" })}*/}
            {/*            text={intl.formatMessage({ id: "home.noForms.text" })}*/}
            {/*            buttonProps={{*/}
            {/*                text: intl.formatMessage({ id: "nav.create" }),*/}
            {/*                onClick: () => navigate('/create'),*/}
            {/*            }}*/}
            {/*        />*/}
            {/*    ) : (*/}
            {/*        <div className={styles.formsList}>*/}
            {/*            {forms.map(form => (*/}
            {/*                <FormListItem key={form.id} form={form} />*/}
            {/*            ))}*/}
            {/*        </div>*/}
            {/*    )}*/}
            {/*</div>*/}
        </div>
    );
};

export default HomePage;
